// utils/logoutNow.js
import { auth, rtdb } from "../firebase";
import { ref, set, serverTimestamp, onDisconnect } from "firebase/database";
import { unregisterFcmForCurrentUser } from "../services/fcmRegistration";
import { clearNativeCallSessionForLogout } from "../plugins/NativeLivoraCall";
import { clearAllNativeCallPreparation } from "../calls/nativeCallPreparation";
import { clearPendingNativeNotificationHandoff } from "../plugins/NativeNotificationCenter";

// Country-detection account-isolation fix: this key must never survive a
// logout, or the next account signing in on this same browser/WebView
// installation would silently inherit whatever country a PREVIOUS account
// detected (proven cross-account leak - see
// src/components/SelectGenderPage.js's REAL_COUNTRY_LS_KEY, kept as a
// duplicated literal here rather than a shared import so this low-level
// logout util stays decoupled from the onboarding UI component).
const REAL_COUNTRY_LS_KEY = "realCountryISO2";

export async function logoutNow() {
  const uid = auth.currentUser?.uid;

  // Removed unconditionally, first, regardless of what else in this
  // function succeeds or fails below.
  localStorage.removeItem(REAL_COUNTRY_LS_KEY);

  // ✅ امنع PresenceGate من كتابة online أثناء logout
  sessionStorage.setItem("presence_blocked", "1");

  if (uid) {
    // ✅ نفس مسار Cloud Function: /status/{uid}
    const pRef = ref(rtdb, `status/${uid}`);

    // ✅ ألغِ onDisconnect إن كان مضبوط سابقًا
    try {
      await onDisconnect(pRef).cancel();
    } catch {}

    // ✅ اكتب Offline بشكل صريح
    try {
      await set(pRef, {
        state: "offline",
        inApp: false,
        lastChanged: serverTimestamp(),
        reason: "logout",
      });
    } catch (e) {
      console.warn("RTDB offline write failed:", e);
    }
  }

  try {
    await unregisterFcmForCurrentUser();
  } catch (e) {
    console.warn("unregisterFcm failed (continue logout):", e);
  }

  // Phase N2A: real logout - clear any prepared/signed-in native Firebase
  // session so it can never survive into a different account on this
  // device. Best-effort; never blocks logout if the plugin is unavailable.
  try {
    clearAllNativeCallPreparation();
    await clearNativeCallSessionForLogout();
  } catch (e) {
    console.warn("clearNativeCallSessionForLogout failed (continue logout):", e);
  }

  // A route queued by the native Notification Center for this account must
  // never survive into a different account's session after a fresh login
  // on the same device - same account-isolation class as REAL_COUNTRY_LS_KEY
  // above, just for the native handoff instead of localStorage.
  try {
    await clearPendingNativeNotificationHandoff();
  } catch (e) {
    console.warn("clearPendingNativeNotificationHandoff failed (continue logout):", e);
  }

  // ✅ تسجيل الخروج من Firebase Auth
  await auth.signOut();

  // لا تزيل presence_blocked هنا — PresenceGate سيزيلها عند login القادم
}